
import { defineComponent, ref, reactive, toRefs, onMounted } from 'vue'
import Menu from '@/views/layout/menu.vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Page from '@/views/pageAll/content.vue'
import ForCon from '@/views/pageAll/forCon.vue'
import store from '@/store/index'
import Breadcrumb from '@/components/Breadcrumb.vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import axsios from 'axios'
export default defineComponent({
  components: {
    Menu,
    DoubleRightOutlined,
    Breadcrumb,
    Page,
    ForCon
  },
  setup(props, context) {
    const pageData: any = reactive({
      menulist: [],
      topMenu: [],
      leftMenu: [],
      currentmodel: '',
      topselected: [],
      leftselected: [],
      query: {},
      searchData: []
    })

    const route: any = useRoute()
    const menu: any = ref([])
    const routeObj = router.options.routes.filter((item: any) => item.name === 'Layout')
    if (Object.keys(route.query).length) {
      window.localStorage.setItem('operationmanuallocalStorage', JSON.stringify(route.query))
      pageData.query = route.query
    }
    if (!Object.keys(route.query).length && window.localStorage.getItem('operationmanuallocalStorage')) {
      pageData.query = JSON.parse(window.localStorage.getItem('operationmanuallocalStorage') || '{}')
    }
    function handleClickTop(data: any) {
      pageData.currentmodel = data.key
      const arr = pageData.menulist.filter((item: any) => {
        return item.key === data.key
      })
      pageData.leftMenu = (arr[0] || {}).children
      const a: any = []
      recursionsetroute(pageData.leftMenu[0], a)
      pageData.leftselected = a
      pageData.topselected = [pageData.currentmodel]
      router.push({
        name: pageData.leftselected[0],
        query: route.query
      })
    }
    function handleClickleft(data: any) {
      pageData.leftselected = data.keyPath
      router.push({
        name: data.key,
        params: {
          menu: JSON.stringify(menu)
        },
        query: route.query
      })
    }
    function recursionRoutes(data: any) {
      const arr: any = []
      if (data.length) {
        data.forEach((item: any) => {
          const a = {
            name: item.key,
            path: item.key,
            component: Page,
            props: true,
            children: recursionRoutes(item.children || []),
            meta: {
              page: JSON.stringify(item.page),
              title: item.title
            }
          }
          arr.push(a)
          const _route: any = routeObj[0].children
          _route.push(a)
        })
      }
      return arr
    }
    function recursionsetroute(data: any, arr: any) {
      const obj = data
      if ((obj.children || []).length) {
        recursionsetroute(obj.children[0], arr)
      } else {
        arr.push(obj.key)
        return arr
      }
    }
    function getFile() {
      let url = ''
      url = process.env.VUE_APP_BASE_API
      const softNameAbbr = route.query.softNameAbbr || JSON.parse(window.localStorage.getItem('operationmanuallocalStorage') || '{}').softNameAbbr
      switch (softNameAbbr) {
        case 'dyzt':
          url = process.env.VUE_APP_BASE_DYZT_JSONFILE
          break
        case 'tzyk':
          url = process.env.VUE_APP_BASE_DYZT_JSONFILE
          break
        case 'fdgmg':
          url = process.env.VUE_APP_BASE_FDGMG_JSONFILE
          break
        case 'jfzt':
          url = process.env.VUE_APP_BASE_JFQJ_JSONFILE
          break
        case 'jfztADV':
          url = process.env.VUE_APP_BASE_JFQL_JSONFILE
          break
        case 'flgmg':
          url = process.env.VUE_APP_BASE_FLGMG_JSONFILE
          break
        case 'hxg':
          url = process.env.VUE_APP_BASE_HXG_JSONFILE
          break
        case 'hzyq':
          url = process.env.VUE_APP_BASE_HZYQ_JSONFILE
          break
      }
      // 加时间戳，避免走缓存
      url = url + '/menulist.json?' + Date.now()
      if (!pageData.query.softNameAbbr) {
        url = process.env.VUE_APP_BASE_API + '/menulist.json'
      }
      if (!document.domain.includes('test-')) {
        url = url.replace('test-', '')
      }
      axsios.get(url).then((res: any) => {
        menu.value = res.data
        // setroutes()
      })
    }
    function setroutes() {
      pageData.menulist = menu.value
      pageData.leftMenu = pageData.menulist[0].children
      pageData.topMenu = JSON.parse(JSON.stringify(pageData.menulist)).filter((item: any) => {
        delete item.children
        return item
      })
      const arr = pageData.menulist
      const _route: any = recursionRoutes(arr)
      store.commit('FRESH_MYROUTES', _route)
      pageData.searchData = handleSwarchData(_route)
      if (route.name === 'Layout') {
        pageData.currentmodel = pageData.menulist[0].key
        pageData.leftMenu = pageData.menulist.filter((item: any) => {
          return item.key === pageData.currentmodel
        })
      } else {
        pageData.currentmodel = (route.path.split('/home/') || '')[1].split('/')[0]
        pageData.leftMenu = pageData.menulist.filter((item: any) => {
          return item.key === pageData.currentmodel
        })
      }
      const a: any = []
      pageData.topselected = [pageData.leftMenu[0].key]
      recursionsetroute(pageData.leftMenu[0], a)
      pageData.leftselected = a
      pageData.leftMenu = pageData.leftMenu[0].children
      let pathname = pageData.leftselected[0]
      if (route.name && route.name !== 'Layout') {
        pathname = route.name
        pageData.leftselected = [route.name]
      }
      if (pageData.query.key) {
        searchJump({
          key: pageData.query.key,
          keyPath: [pageData.query.key],
          selectedKeys: [pageData.query.key]
        })
      } else {
        router.push({
          name: pathname,
          params: {
            menu: JSON.stringify(menu)
          },
          query: pageData.query
        })
      }
    }
    getFile()

    function setmenulist(i: string) {
      switch (i) {
        case '1':
          pageData.leftMenu = pageData.menulist[0].children
          break
        case '2':
          pageData.leftMenu = pageData.menulist[1].children
          break
        case '3':
          pageData.leftMenu = pageData.menulist[2].children
          break
      }
      return pageData.leftMenu
    }
    function handleSwarchData(route: any) {
      // 将可以点击的菜单筛选出来组成一个数组
      const arr: any = []
      if (route.length) {
        route.forEach((item: any) => {
          if (item.children.length) {
            item.children.forEach((r: any) => {
              if (!r.children.length) {
                arr.push(r)
              } else {
                const obj = handleSwarchData(r.children)
                arr.push(...obj)
              }
            })
          } else {
            arr.push(item)
          }
        })
      }
      return arr
    }
    function searchJump(data: any) {
      // 先判断当前顶部导航与跳转页面的顶部导航是否一致
      pageData.currentmodel = data.key.split('.')[0]
      const arr = pageData.menulist.filter((item: any) => {
        return item.key === pageData.currentmodel
      })
      pageData.leftMenu = (arr[0] || {}).children
      const a: any = []
      recursionsetroute(pageData.leftMenu[0], a)
      pageData.leftselected = a
      pageData.topselected = [pageData.currentmodel]
      pageData.leftselected = data.keyPath
      router.push({
        name: data.key,
        params: {
          menu: JSON.stringify(menu)
        },
        query: route.query
      })
    }
    return {
      ...toRefs(pageData),
      ...mapMutations(['FRESH_MYROUTES']),
      handleClickTop,
      recursionRoutes,
      handleClickleft,
      setmenulist,
      recursionsetroute,
      menu,
      getFile,
      setroutes,
      searchJump
    }
  }
})
